module.exports = __webpack_public_path__ + "static/media/section1-owners.4ce1fa26.svg";